// Generated file : do not modify

import { Schema } from '@/framework/base/classes/Schema';
export enum Modules {
  NONE = 'NONE',
  ABONNEMENT = 'ABONNEMENT',
  ADMIN = 'ADMIN',
  CART = 'CART',
  COMPTA = 'COMPTA',
  DOCUMENT = 'DOCUMENT',
  MARKETING = 'MARKETING',
  NOTIFICATION = 'NOTIFICATION',
  PREFERENCE = 'PREFERENCE',
  PROFIL = 'PROFIL',
  PROJET = 'PROJET',
  SALARIE = 'SALARIE',
  ETABLISSEMENT = 'ETABLISSEMENT',
  SUPPORT = 'SUPPORT'
};

export enum Fiches {
  NONE = 'NONE',
  ABONNEMENT_LIST = 'ABONNEMENT_LIST',
  SUBSCRIPTION = 'SUBSCRIPTION',
  ADMIN_INFO = 'ADMIN_INFO',
  ADMIN_TABLE = 'ADMIN_TABLE',
  CART_ITEM_LIST = 'CART_ITEM_LIST',
  POINTAGES = 'POINTAGES',
  MANUAL_BILLING_DOCUMENTS = 'MANUAL_BILLING_DOCUMENTS',
  MANUAL_BILLING_DOCUMENT = 'MANUAL_BILLING_DOCUMENT',
  CHECKS_RECU = 'CHECKS_RECU',
  CHECKS_EMIS = 'CHECKS_EMIS',
  PRELEVEMENT_EMIS = 'PRELEVEMENT_EMIS',
  CARTE_EMIS = 'CARTE_EMIS',
  VIREMENTS_RECU = 'VIREMENTS_RECU',
  VIREMENTS_EMIS = 'VIREMENTS_EMIS',
  CREDIT_LIMITS = 'CREDIT_LIMITS',
  VIREMENT_SALARIE = 'VIREMENT_SALARIE',
  VIREMENT_ETABLISSEMENT = 'VIREMENT_ETABLISSEMENT',
  BANQUE = 'BANQUE',
  RAPPROCHEMENT = 'RAPPROCHEMENT',
  DOCUMENT_LIST = 'DOCUMENT_LIST',
  DOCUMENT_VIEWER = 'DOCUMENT_VIEWER',
  CONTRAT_VIEWER = 'CONTRAT_VIEWER',
  PAIE_VIEWER = 'PAIE_VIEWER',
  SIMULATION = 'SIMULATION',
  STAT_CLIENT = 'STAT_CLIENT',
  NOTIFICATION = 'NOTIFICATION',
  PREFERENCE = 'PREFERENCE',
  PROFIL = 'PROFIL',
  PROJET_LIST = 'PROJET_LIST',
  PROJET_CONTRATS = 'PROJET_CONTRATS',
  PROJET = 'PROJET',
  CONTRAT = 'CONTRAT',
  PAIE = 'PAIE',
  SALARIE_LIST = 'SALARIE_LIST',
  SALARIE_ABSTRACT = 'SALARIE_ABSTRACT',
  SALARIE = 'SALARIE',
  ETABLISSEMENT_LIST = 'ETABLISSEMENT_LIST',
  ETABLISSEMENT_ABSTRACT = 'ETABLISSEMENT_ABSTRACT',
  ETABLISSEMENT = 'ETABLISSEMENT',
  TEST_PAIES = 'TEST_PAIES',
  TRANSACTION_CAISSE = 'TRANSACTION_CAISSE',
  TRANSACTION_SALARIE = 'TRANSACTION_SALARIE',
  TRANSACTION_ETABLISSEMENT = 'TRANSACTION_ETABLISSEMENT',
  VERSEMENT_EMPLOYEUR = 'VERSEMENT_EMPLOYEUR',
  GESTION_AEM = 'GESTION_AEM',
  ATTESTATION_COMPTE = 'ATTESTATION_COMPTE',
  OBJET_METIER = 'OBJET_METIER',
  CONTAINER = 'CONTAINER',
};

export enum Sections {
  NONE = 'NONE',
  RIB = 'RIB',
  PAYMENT = 'PAYMENT',
  SUBSCRIPTION = 'SUBSCRIPTION',
  MANDAT_VIEWER = 'MANDAT_VIEWER',
  ADMIN_RESOURCE = 'ADMIN_RESOURCE',
  ADMIN_DIALOG = 'ADMIN_DIALOG',
  GRAPH_DIALOG = 'GRAPH_DIALOG',
  CONTRAT_TEMPLATE_CONFIG = 'CONTRAT_TEMPLATE_CONFIG',
  CHECK_RECEIVED = 'CHECK_RECEIVED',
  DELIVERY = 'DELIVERY',
  MANUAL_BILLING_DOCUMENT = 'MANUAL_BILLING_DOCUMENT',
  AUTHORIZED_CREDIT = 'AUTHORIZED_CREDIT',
  CONTACT = 'CONTACT',
  DOCUMENT_VIEWER = 'DOCUMENT_VIEWER',
  IMPORT_DOC = 'IMPORT_DOC',
  IMPORT_STATUS = 'IMPORT_STATUS',
  EXTERN_URL = 'EXTERN_URL',
  DIALOG = 'DIALOG',
  DEFINE_META_ATTRIB = 'DEFINE_META_ATTRIB',
  VALUATE_META_ATTRIB = 'VALUATE_META_ATTRIB',
  CONNEXION = 'CONNEXION',
  CONTRAT_VIEWER = 'CONTRAT_VIEWER',
  PAIE_VIEWER = 'PAIE_VIEWER',
  LIEU = 'LIEU',
  ADRESSE = 'ADRESSE',
  NUMERO_OBJET = 'NUMERO_OBJET',
  ETABLISSEMENT_COMMERCIAL = 'ETABLISSEMENT_COMMERCIAL',
  ETABLISSEMENT_INFORMATION = 'ETABLISSEMENT_INFORMATION',
  ETABLISSEMENT_CONTACT = 'ETABLISSEMENT_CONTACT',
  ETABLISSEMENT_INFORMATION_JURIDIQUE = 'ETABLISSEMENT_INFORMATION_JURIDIQUE',
  ETABLISSEMENT_AFFLIATION = 'ETABLISSEMENT_AFFLIATION',
  ETABLISSEMENT_REPRESENTANT = 'ETABLISSEMENT_REPRESENTANT',
  ABONNEMENT = 'ABONNEMENT',
  FRACTION_DSN = 'FRACTION_DSN',
  APPRENTI = 'APPRENTI',
  ACCIDENT_TRAVAIL = 'ACCIDENT_TRAVAIL',
  ACCORD_COLLECTIF = 'ACCORD_COLLECTIF',
  DEMANDE_ATTESTATION = 'DEMANDE_ATTESTATION',
  GROUPEMENT_FACTURE = 'GROUPEMENT_FACTURE',
  CGU = 'CGU',
  USER = 'USER',
  ABONNEMENT_LIST = 'ABONNEMENT_LIST',
  CART_ITEM_LIST = 'CART_ITEM_LIST',
  POINTAGES = 'POINTAGES',
  MANUAL_BILLING_DOCUMENT_LIST = 'MANUAL_BILLING_DOCUMENT_LIST',
  CHECK_WAITED_LIST = 'CHECK_WAITED_LIST',
  CHECK_RECEIVED_LIST = 'CHECK_RECEIVED_LIST',
  CHECK_DELIVERY_LIST = 'CHECK_DELIVERY_LIST',
  CHECK_PROCESSING_LIST = 'CHECK_PROCESSING_LIST',
  CHECK_EMITED_LIST = 'CHECK_EMITED_LIST',
  CHECK_PAYED_LIST = 'CHECK_PAYED_LIST',
  PRELEVEMENT_DELIVERY_LIST = 'PRELEVEMENT_DELIVERY_LIST',
  PRELEVEMENT_DELIVERY_DETAIL = 'PRELEVEMENT_DELIVERY_DETAIL',
  CARTE_DELIVERY_LIST = 'CARTE_DELIVERY_LIST',
  CARTE_EMITTED_LIST = 'CARTE_EMITTED_LIST',
  VIREMENT_WAITED_LIST = 'VIREMENT_WAITED_LIST',
  VIREMENT_RECEIVED_LIST = 'VIREMENT_RECEIVED_LIST',
  VIREMENT_DELIVERY_LIST = 'VIREMENT_DELIVERY_LIST',
  VIREMENT_DELIVERY_DETAIL = 'VIREMENT_DELIVERY_DETAIL',
  CREDIT_LIMIT_LIST = 'CREDIT_LIMIT_LIST',
  VIREMENT_SALARIE = 'VIREMENT_SALARIE',
  VIREMENT_ETABLISSEMENT = 'VIREMENT_ETABLISSEMENT',
  BANK_LIST = 'BANK_LIST',
  BANK_DETAIL = 'BANK_DETAIL',
  RAPPROCHEMENT = 'RAPPROCHEMENT',
  DOCUMENT_LIST = 'DOCUMENT_LIST',
  STAT_SIMU = 'STAT_SIMU',
  LIST_SIMU = 'LIST_SIMU',
  STAT_CLIENT = 'STAT_CLIENT',
  NOTIFICATION = 'NOTIFICATION',
  MODE_CONNEXION = 'MODE_CONNEXION',
  PROJET_LIST = 'PROJET_LIST',
  CONTRAT_SALARIE = 'CONTRAT_SALARIE',
  CRENEAUX = 'CRENEAUX',
  REMUNERATION = 'REMUNERATION',
  AFFILIATION_PROCESS = 'AFFILIATION_PROCESS',
  CONTRAT = 'CONTRAT',
  DPAE = 'DPAE',
  PAIES = 'PAIES',
  PROJET = 'PROJET',
  CONTRAT_LIST = 'CONTRAT_LIST',
  SALARIE_LIST = 'SALARIE_LIST',
  SALARIE_IDENTITE_ABSTRACT = 'SALARIE_IDENTITE_ABSTRACT',
  SALARIE_COORDONNEES_ABSTRACT = 'SALARIE_COORDONNEES_ABSTRACT',
  SALARIE_INFO_COMPLEMENTAIRES_ABSTRACT = 'SALARIE_INFO_COMPLEMENTAIRES_ABSTRACT',
  SALARIE_ETAT_CIVIL_ABSTRACT = 'SALARIE_ETAT_CIVIL_ABSTRACT',
  SALARIE_RIB_ABSTRACT = 'SALARIE_RIB_ABSTRACT',
  SALARIE = 'SALARIE',
  SALARIE_CIVILITE = 'SALARIE_CIVILITE',
  SALARIE_INFORMATIONS = 'SALARIE_INFORMATIONS',
  SALARIE_FISCALITE = 'SALARIE_FISCALITE',
  ETABLISSEMENT_LIST = 'ETABLISSEMENT_LIST',
  ETABLISSEMENT_IDENTITE_ABSTRACT = 'ETABLISSEMENT_IDENTITE_ABSTRACT',
  ETABLISSEMENT_ADRESSE_ABSTRACT = 'ETABLISSEMENT_ADRESSE_ABSTRACT',
  ETABLISSEMENT_REPRESENTANT_ABSTRACT = 'ETABLISSEMENT_REPRESENTANT_ABSTRACT',
  ETABLISSEMENT_GESTIONNAIRES_ABSTRACT = 'ETABLISSEMENT_GESTIONNAIRES_ABSTRACT',
  ETABLISSEMENT_JURIDIQUE_ABSTRACT = 'ETABLISSEMENT_JURIDIQUE_ABSTRACT',
  DEMANDE_ATTESTATION_ABSTRACT = 'DEMANDE_ATTESTATION_ABSTRACT',
  ETABLISSEMENT_ACCIDENT_TRAVAIL_ABSTRACT = 'ETABLISSEMENT_ACCIDENT_TRAVAIL_ABSTRACT',
  ETABLISSEMENT_DOCUMENT_ABSTRACT = 'ETABLISSEMENT_DOCUMENT_ABSTRACT',
  ETABLISSEMENT_PAYMENT_ABSTRACT = 'ETABLISSEMENT_PAYMENT_ABSTRACT',
  ETABLISSEMENT_CART_ABSTRACT = 'ETABLISSEMENT_CART_ABSTRACT',
  ETABLISSEMENT_APPRENTI_ABSTRACT = 'ETABLISSEMENT_APPRENTI_ABSTRACT',
  ETABLISSEMENT_IDENTITE = 'ETABLISSEMENT_IDENTITE',
  ETABLISSEMENT_CONTACTS = 'ETABLISSEMENT_CONTACTS',
  ETABLISSEMENT_AFFILIATIONS = 'ETABLISSEMENT_AFFILIATIONS',
  ETABLISSEMENT_CAISSES = 'ETABLISSEMENT_CAISSES',
  DEMANDE_ATTESTATION_LIST = 'DEMANDE_ATTESTATION_LIST',
  ACCIDENT_TRAVAIL_LIST = 'ACCIDENT_TRAVAIL_LIST',
  GESTIONNAIRES_PAIE = 'GESTIONNAIRES_PAIE',
  APPRENTI_LIST = 'APPRENTI_LIST',
  PAYMENT_MEANS_LIST = 'PAYMENT_MEANS_LIST',
  PRELEV_MEANS = 'PRELEV_MEANS',
  SALAIRE_MEANS = 'SALAIRE_MEANS',
  REGLEMENT_LIST = 'REGLEMENT_LIST',
  ETABLISSEMENT_LOGO = 'ETABLISSEMENT_LOGO',
  ETABLISSEMENT_DOCUMENT_LIST = 'ETABLISSEMENT_DOCUMENT_LIST',
  PARAMETRES_PAIE = 'PARAMETRES_PAIE',
  TRANSACTION_CAISSE = 'TRANSACTION_CAISSE',
  TRANSACTION_SALARIE = 'TRANSACTION_SALARIE',
  TRANSACTION_ETABLISSEMENT = 'TRANSACTION_ETABLISSEMENT',
  VERSEMENT_EMPLOYEUR = 'VERSEMENT_EMPLOYEUR',
  GESTION_AEM = 'GESTION_AEM',
  ATTESTATION_COMPTE = 'ATTESTATION_COMPTE',
  OBJET_METIER_LIST = 'OBJET_METIER_LIST'
};

export const schema: Schema = {
  "modules": [
    {
      "name": "Abonnement",
      "label": "Abonnement",
      "fiches": [
        {
          "name": "AbonnementList",
          "label": "",
          "sections": [
            {
              "name": "AbonnementList",
              "label": "Abonnements(s)",
              "objType": "Subscription",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "Subscription",
          "label": "",
          "sections": [
            {
              "name": "Subscription",
              "label": "Abonnements",
              "objType": "Subscription",
              "attributs": [
                {
                  "name": "subscriptionTypeId",
                  "required": true,
                  "readOnly": false
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "name": "Admin",
      "label": "Administration",
      "fiches": [
        {
          "name": "AdminInfo",
          "label": "",
          "sections": [
          ]
        },
        {
          "name": "AdminTable",
          "label": "",
          "sections": [
          ]
        }
      ]
    },
    {
      "name": "Cart",
      "label": "Mon panier",
      "fiches": [
        {
          "name": "CartItemList",
          "label": "",
          "sections": [
            {
              "name": "CartItemList",
              "label": "Mon panier",
              "objType": "Cart",
              "attributs": [
              ]
            }
          ]
        }
      ]
    },
    {
      "name": "Compta",
      "label": "Comptabilité",
      "fiches": [
        {
          "name": "Pointages",
          "label": "",
          "sections": [
            {
              "name": "Pointages",
              "label": "Pointages",
              "objType": "User",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "ManualBillingDocuments",
          "label": "Factures et avoirs manuels",
          "sections": [
            {
              "name": "ManualBillingDocumentList",
              "label": "Factures et avoirs manuels",
              "objType": "ManualBillingDocument",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "ManualBillingDocument",
          "label": "Facture ou avoir manuel",
          "sections": [
            {
              "name": "ManualBillingDocument",
              "label": "Facture ou avoir manuel",
              "objType": "ManualBillingDocument",
              "attributs": [
                {
                  "name": "etablissementId",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "kind",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "inCart",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "ledgerCode",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "effectiveAt",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "documentReference",
                  "required": false,
                  "readOnly": true
                },
                {
                  "name": "reference",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "label",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "amountHt",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "vatRate",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "amountTva",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "amountTtc",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "paymentMethod",
                  "required": false,
                  "readOnly": false
                }
              ]
            }
          ]
        },
        {
          "name": "ChecksRecu",
          "label": "",
          "sections": [
            {
              "name": "CheckWaitedList",
              "label": "Chèques attendus",
              "objType": "Transaction",
              "attributs": [
              ]
            },
            {
              "name": "CheckReceivedList",
              "label": "Chèques reçus",
              "objType": "Transaction",
              "attributs": [
              ]
            },
            {
              "name": "CheckDeliveryList",
              "label": "Bordereaux de remise",
              "objType": "Delivery",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "ChecksEmis",
          "label": "",
          "sections": [
            {
              "name": "CheckProcessingList",
              "label": "Chèques a émettre",
              "objType": "Transaction",
              "attributs": [
              ]
            },
            {
              "name": "CheckEmitedList",
              "label": "Chèques émis",
              "objType": "Transaction",
              "attributs": [
              ]
            },
            {
              "name": "CheckPayedList",
              "label": "Chèques émis encaissés",
              "objType": "Transaction",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "PrelevementEmis",
          "label": "",
          "sections": [
            {
              "name": "PrelevementDeliveryList",
              "label": "Fichiers de prélèvements",
              "objType": "Delivery",
              "attributs": [
              ]
            },
            {
              "name": "PrelevementDeliveryDetail",
              "label": "Détail du fichier de prélèvement",
              "objType": "Transaction",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "CarteEmis",
          "label": "",
          "sections": [
            {
              "name": "CarteDeliveryList",
              "label": "Relevés cartes bancaires",
              "objType": "Delivery",
              "attributs": [
              ]
            },
            {
              "name": "CarteEmittedList",
              "label": "Détail du relevé",
              "objType": "Transaction",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "VirementsRecu",
          "label": "",
          "sections": [
            {
              "name": "VirementWaitedList",
              "label": "Virements attendus",
              "objType": "Transaction",
              "attributs": [
              ]
            },
            {
              "name": "VirementReceivedList",
              "label": "Virements reçus",
              "objType": "Transaction",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "VirementsEmis",
          "label": "",
          "sections": [
            {
              "name": "VirementDeliveryList",
              "label": "Fichiers de virements",
              "objType": "Delivery",
              "attributs": [
              ]
            },
            {
              "name": "VirementDeliveryDetail",
              "label": "Détail du fichier de virements",
              "objType": "Transaction",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "CreditLimits",
          "label": "Encours autorisés",
          "sections": [
            {
              "name": "CreditLimitList",
              "label": "Encours autorisés",
              "objType": "Support",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "VirementSalarie",
          "label": "",
          "sections": [
            {
              "name": "VirementSalarie",
              "label": "Paiement des salariés",
              "objType": "Support",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "VirementEtablissement",
          "label": "",
          "sections": [
            {
              "name": "VirementEtablissement",
              "label": "Remboursement des établissements",
              "objType": "Support",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "Banque",
          "label": "",
          "sections": [
            {
              "name": "BankList",
              "label": "Ecritures par jour",
              "objType": "BankLog",
              "attributs": [
              ]
            },
            {
              "name": "BankDetail",
              "label": "Détail quotidien",
              "objType": "BankLog",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "Rapprochement",
          "label": "",
          "sections": [
            {
              "name": "Rapprochement",
              "label": "Rapprochements manuels",
              "objType": "Transaction",
              "attributs": [
              ]
            }
          ]
        }
      ]
    },
    {
      "name": "Document",
      "label": "Mes documents",
      "fiches": [
        {
          "name": "DocumentList",
          "label": "",
          "sections": [
            {
              "name": "DocumentList",
              "label": "Document(s)",
              "objType": "Document",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "DocumentViewer",
          "label": "",
          "sections": [
            {
              "name": "DocumentViewer",
              "label": "Document",
              "objType": "Document",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "ContratViewer",
          "label": "",
          "sections": [
            {
              "name": "ContratViewer",
              "label": "Contrat de travail",
              "objType": "Contrat",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "PaieViewer",
          "label": "",
          "sections": [
            {
              "name": "PaieViewer",
              "label": "Fiche de paie",
              "objType": "Paie",
              "attributs": [
              ]
            }
          ]
        }
      ]
    },
    {
      "name": "Marketing",
      "label": "Marketing",
      "fiches": [
        {
          "name": "Simulation",
          "label": "",
          "sections": [
            {
              "name": "StatSimu",
              "label": "Statistiques des simulations",
              "objType": "Simulation",
              "attributs": [
              ]
            },
            {
              "name": "ListSimu",
              "label": "Liste des simulations",
              "objType": "Simulation",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "StatClient",
          "label": "",
          "sections": [
            {
              "name": "StatClient",
              "label": "Liste Client",
              "objType": "StatClient",
              "attributs": [
              ]
            }
          ]
        }
      ]
    },
    {
      "name": "Notification",
      "label": "Centre d'actions",
      "fiches": [
        {
          "name": "Notification",
          "label": "",
          "sections": [
            {
              "name": "Notification",
              "label": "Liste notifications",
              "objType": "Notif",
              "attributs": [
              ]
            }
          ]
        }
      ]
    },
    {
      "name": "Preference",
      "label": "Mes préférences",
      "fiches": [
        {
          "name": "Preference",
          "label": "",
          "sections": [
            {
              "name": "ModeConnexion",
              "label": "Mes préférences",
              "objType": "User",
              "attributs": [
              ]
            }
          ]
        }
      ]
    },
    {
      "name": "Profil",
      "label": "Mon profil",
      "fiches": [
        {
          "name": "Profil",
          "label": "",
          "sections": [
            {
              "name": "Contact",
              "label": "Contact",
              "objType": "Contact",
              "attributs": [
                {
                  "name": "civiliteId",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "prenom",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "nom",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "mail",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "numero",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "qualiteId",
                  "required": false,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "Adresse",
              "label": "Adresse",
              "objType": "Adresse",
              "attributs": [
                {
                  "name": "adresse1",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "adresse2",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "codePostal",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "ville",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "paysId",
                  "required": true,
                  "readOnly": false
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "name": "Projet",
      "label": "",
      "fiches": [
        {
          "name": "ProjetList",
          "label": "Mes projets de paie",
          "sections": [
            {
              "name": "ProjetList",
              "label": "Projets de paie",
              "objType": "Projet",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "ProjetContrats",
          "label": "Contrat",
          "sections": [
            {
              "name": "ContratSalarie",
              "label": "Salarié",
              "objType": "Contrat",
              "attributs": [
                {
                  "name": "emploiId",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "conventionAppliqueeId",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "salarieId",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "exoEtranger",
                  "required": false,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "Creneaux",
              "label": "Créneaux",
              "objType": "Creneau",
              "attributs": [
                {
                  "name": "date",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "heureDebut",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "heureFin",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "activiteId",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "lieuId",
                  "required": false,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "Remuneration",
              "label": "Rémunération",
              "objType": "Contrat",
              "attributs": [
                {
                  "name": "editBaseSalarie",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "id",
                  "required": true,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "AffiliationProcess",
              "label": "Affiliation France Travail",
              "objType": "Contrat",
              "attributs": [
              ]
            },
            {
              "name": "Contrat",
              "label": "Contrat de travail",
              "objType": "Contrat",
              "attributs": [
                {
                  "name": "contratTemplateId",
                  "required": true,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "Dpae",
              "label": "Déclaration préalable à l'embauche",
              "objType": "Contrat",
              "attributs": [
              ]
            },
            {
              "name": "Paies",
              "label": "Bulletin de paie",
              "objType": "Paie",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "Projet",
          "label": "Projet de paie",
          "sections": [
            {
              "name": "Projet",
              "label": "PROJET",
              "objType": "Projet",
              "attributs": [
                {
                  "name": "nom",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "numeroObjetId",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "etablissementId",
                  "required": true,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "ValuateMetaAttrib",
              "label": "Affiche un dialogue pour valoriser des meta-attributs",
              "objType": "MetaAttrib",
              "attributs": [
              ]
            },
            {
              "name": "ContratList",
              "label": "Contrat(s)",
              "objType": "Contrat",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "Contrat",
          "label": "",
          "sections": [
            {
              "name": "ContratViewer",
              "label": "Contrat de travail",
              "objType": "Contrat",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "Paie",
          "label": "",
          "sections": [
            {
              "name": "PaieViewer",
              "label": "Fiche de paie",
              "objType": "Paie",
              "attributs": [
              ]
            }
          ]
        }
      ]
    },
    {
      "name": "Salarie",
      "label": "Mes salariés",
      "fiches": [
        {
          "name": "SalarieList",
          "label": "",
          "sections": [
            {
              "name": "SalarieList",
              "label": "Salariés",
              "objType": "Salarie",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "SalarieAbstract",
          "label": "",
          "sections": [
            {
              "name": "SalarieIdentiteAbstract",
              "label": "",
              "objType": "Salarie",
              "attributs": [
              ]
            },
            {
              "name": "SalarieCoordonneesAbstract",
              "label": "Coordonnées",
              "objType": "Salarie",
              "attributs": [
              ]
            },
            {
              "name": "SalarieInfoComplementairesAbstract",
              "label": "",
              "objType": "Salarie",
              "attributs": [
              ]
            },
            {
              "name": "SalarieEtatCivilAbstract",
              "label": "",
              "objType": "Salarie",
              "attributs": [
              ]
            },
            {
              "name": "SalarieRibAbstract",
              "label": "",
              "objType": "Salarie",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "Salarie",
          "label": "",
          "sections": [
            {
              "name": "Salarie",
              "label": "Salarié",
              "objType": "Salarie",
              "attributs": [
                {
                  "name": "avatar",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "civiliteId",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "prenom",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "nom",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "mail",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "numero",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "identifiant",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "emploiId",
                  "required": false,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "Adresse",
              "label": "Adresse",
              "objType": "Adresse",
              "attributs": [
                {
                  "name": "adresse1",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "adresse2",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "codePostal",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "ville",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "paysId",
                  "required": true,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "SalarieCivilite",
              "label": "Etat civil",
              "objType": "Salarie",
              "attributs": [
                {
                  "name": "nomNaissance",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "dateNaissance",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "villeNaissance",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "departementNaissance",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "paysNaissanceId",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "paysNationaliteId",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "numeroSecu",
                  "required": true,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "SalarieInformations",
              "label": "Informations complémentaires",
              "objType": "Salarie",
              "attributs": [
                {
                  "name": "pseudo",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "statutHandicap",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "dateHandicap",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "numeroCongeSpec",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "abattement",
                  "required": false,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "SalarieFiscalite",
              "label": "Fiscalité",
              "objType": "Salarie",
              "attributs": [
                {
                  "name": "fiscalite",
                  "required": true,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "Rib",
              "label": "Compte bancaire",
              "objType": "Rib",
              "attributs": [
                {
                  "name": "iban",
                  "required": true,
                  "readOnly": false
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "name": "Etablissement",
      "label": "Mes établissements",
      "fiches": [
        {
          "name": "EtablissementList",
          "label": "",
          "sections": [
            {
              "name": "EtablissementList",
              "label": "Etablissement(s)",
              "objType": "Etablissement",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "EtablissementAbstract",
          "label": "",
          "sections": [
            {
              "name": "EtablissementIdentiteAbstract",
              "label": "",
              "objType": "Etablissement",
              "attributs": [
              ]
            },
            {
              "name": "EtablissementAdresseAbstract",
              "label": "",
              "objType": "Etablissement",
              "attributs": [
              ]
            },
            {
              "name": "EtablissementRepresentantAbstract",
              "label": "Contacts",
              "objType": "Etablissement",
              "attributs": [
              ]
            },
            {
              "name": "EtablissementGestionnairesAbstract",
              "label": "",
              "objType": "Etablissement",
              "attributs": [
              ]
            },
            {
              "name": "EtablissementJuridiqueAbstract",
              "label": "Informations juridiques et affiliations",
              "objType": "Etablissement",
              "attributs": [
              ]
            },
            {
              "name": "DemandeAttestationAbstract",
              "label": "Attestations de comptes à jour",
              "objType": "Etablissement",
              "attributs": [
              ]
            },
            {
              "name": "EtablissementAccidentTravailAbstract",
              "label": "Données sociales",
              "objType": "Etablissement",
              "attributs": [
              ]
            },
            {
              "name": "EtablissementDocumentAbstract",
              "label": "Documents",
              "objType": "Etablissement",
              "attributs": [
              ]
            },
            {
              "name": "EtablissementPaymentAbstract",
              "label": "Coordonnées bancaires et règlements",
              "objType": "Etablissement",
              "attributs": [
              ]
            },
            {
              "name": "Abonnement",
              "label": "Abonnement et Factures",
              "objType": "Etablissement",
              "attributs": [
              ]
            },
            {
              "name": "EtablissementCartAbstract",
              "label": "",
              "objType": "Etablissement",
              "attributs": [
              ]
            },
            {
              "name": "EtablissementApprentiAbstract",
              "label": "Apprentis",
              "objType": "Etablissement",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "Etablissement",
          "label": "",
          "sections": [
            {
              "name": "EtablissementIdentite",
              "label": "Identité",
              "objType": "Etablissement",
              "attributs": [
                {
                  "name": "alias",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "nom",
                  "required": true,
                  "readOnly": true
                },
                {
                  "name": "ville",
                  "required": false,
                  "readOnly": true
                },
                {
                  "name": "formeJuridiqueId",
                  "required": false,
                  "readOnly": true
                },
                {
                  "name": "soumisTva",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "siret",
                  "required": true,
                  "readOnly": true
                },
                {
                  "name": "brancheId",
                  "required": false,
                  "readOnly": true
                },
                {
                  "name": "conventionId",
                  "required": false,
                  "readOnly": true
                },
                {
                  "name": "t3252",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "t1790",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "trancheEffectifId",
                  "required": false,
                  "readOnly": true
                },
                {
                  "name": "dateCreation",
                  "required": false,
                  "readOnly": true
                }
              ]
            },
            {
              "name": "Adresse",
              "label": "Adresse",
              "objType": "Adresse",
              "attributs": [
                {
                  "name": "adresse1",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "adresse2",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "codePostal",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "ville",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "paysId",
                  "required": true,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "EtablissementContacts",
              "label": "Contact",
              "objType": "Etablissement",
              "attributs": [
                {
                  "name": "representantId",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "mail",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "numero",
                  "required": false,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "EtablissementAffiliations",
              "label": "Affiliations collectées",
              "objType": "Etablissement",
              "attributs": [
                {
                  "name": "poleEmploiAffiliation",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "poleEmploiAdhesion",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "poleEmploiIdentifiant",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "statutLicenceSpectacle",
                  "required": false,
                  "readOnly": true
                }
              ]
            },
            {
              "name": "EtablissementCaisses",
              "label": "Caisses et affiliations",
              "objType": "Etablissement",
              "attributs": [
                {
                  "name": "urssaf",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "fnas",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "congesSpec",
                  "required": false,
                  "readOnly": false
                },
                {
                  "name": "retraiteComplementaireId",
                  "required": false,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "DemandeAttestationList",
              "label": "Attestations de comptes à jour",
              "objType": "Attestation",
              "attributs": [
              ]
            },
            {
              "name": "AccidentTravailList",
              "label": "Taux accident du travail",
              "objType": "AccidentTravail",
              "attributs": [
              ]
            },
            {
              "name": "GestionnairesPaie",
              "label": "Gestionnaires de paie",
              "objType": "Etablissement",
              "attributs": [
              ]
            },
            {
              "name": "ApprentiList",
              "label": "Apprentis",
              "objType": "Apprenti",
              "attributs": [
              ]
            },
            {
              "name": "PaymentMeansList",
              "label": "Moyens de paiement",
              "objType": "PaymentMeans",
              "attributs": [
              ]
            },
            {
              "name": "Abonnement",
              "label": "Abonnement et Factures",
              "objType": "Etablissement",
              "attributs": [
              ]
            },
            {
              "name": "PrelevMeans",
              "label": "Prélèvements à la source",
              "objType": "Etablissement",
              "attributs": [
                {
                  "name": "prelevRibId",
                  "required": true,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "SalaireMeans",
              "label": "Règlement des salaires et frais",
              "objType": "Etablissement",
              "attributs": [
                {
                  "name": "salaireMeansId",
                  "required": true,
                  "readOnly": false
                },
                {
                  "name": "paymentAutoSalaire",
                  "required": true,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "ReglementList",
              "label": "Prochaine facture",
              "objType": "Transaction",
              "attributs": [
                {
                  "name": "etablissementModeFacture",
                  "required": false,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "EtablissementLogo",
              "label": "Logo de l'établissement",
              "objType": "Etablissement",
              "attributs": [
                {
                  "name": "logo",
                  "required": false,
                  "readOnly": false
                }
              ]
            },
            {
              "name": "EtablissementDocumentList",
              "label": "Documents",
              "objType": "Document",
              "attributs": [
              ]
            }
          ]
        }
      ]
    },
    {
      "name": "Support",
      "label": "Support",
      "fiches": [
        {
          "name": "TestPaies",
          "label": "",
          "sections": [
            {
              "name": "ParametresPaie",
              "label": "Paramètres paies",
              "objType": "Support",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "TransactionCaisse",
          "label": "",
          "sections": [
            {
              "name": "TransactionCaisse",
              "label": "Cotisations versées aux caisses sociales",
              "objType": "Support",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "TransactionSalarie",
          "label": "",
          "sections": [
            {
              "name": "TransactionSalarie",
              "label": "Virements émis ou à émettre",
              "objType": "Transaction",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "TransactionEtablissement",
          "label": "",
          "sections": [
            {
              "name": "TransactionEtablissement",
              "label": "Remboursements des établissements",
              "objType": "Transaction",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "VersementEmployeur",
          "label": "",
          "sections": [
            {
              "name": "VersementEmployeur",
              "label": "Règlements des employeurs",
              "objType": "Support",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "GestionAem",
          "label": "",
          "sections": [
            {
              "name": "GestionAem",
              "label": "Gestion des AEM",
              "objType": "Support",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "AttestationCompte",
          "label": "",
          "sections": [
            {
              "name": "AttestationCompte",
              "label": "Attestations de compte à jour",
              "objType": "Attestation",
              "attributs": [
              ]
            }
          ]
        },
        {
          "name": "ObjetMetier",
          "label": "",
          "sections": [
            {
              "name": "ObjetMetierList",
              "label": "Reprises et échecs d'API",
              "objType": "ObjetMetier",
              "attributs": [
              ]
            }
          ]
        }
      ]
    }
  ]
}
